import React from 'react';
import styled from 'styled-components';

const Page = styled.main`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
`;

export function BackofficeRouteUnavailable(): JSX.Element {
  return (
    <Page>
      <h1>Ecommerce is not available</h1>
      <p>This Ecommerce destination is not currently available.</p>
      <a href='/nexus'>Return to Nexus</a>
    </Page>
  );
}
